import type { CSSProperties } from 'react';

/** One hour is this tall; a 25-minute beard trim still fits two lines. */
export const PX_PER_MINUTE = 1.6;
/** Below this a block drops to a single line. */
export const SHORT_BLOCK_MIN = 35;

type Placed = { startMin: number; endMin: number; lane: number; lanes: number };

/** Where a block sits in its column: its minutes set the height, its lane the slice of width. */
export function blockStyle(block: Placed): CSSProperties {
  const minutes = block.endMin - block.startMin;
  return {
    top: block.startMin * PX_PER_MINUTE,
    height: Math.max(minutes * PX_PER_MINUTE - 2, 18),
    left: `calc(${(block.lane / block.lanes) * 100}% + 3px)`,
    width: `calc(${100 / block.lanes}% - 6px)`,
  };
}
